var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useCallback, useMemo, useState } from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../../styles/index";
import { useTranslation } from "../../../hooks/useTranslation";
import { Button } from "../../Button/Button";
import { Divider } from "../../Divider/Divider";
import { Grid } from "../../Grid/Grid";
import { MenuItem } from "../../Menu/MenuItem";
import { MenuList } from "../../Menu/MenuList";
import { Popup } from "../../Popup/Popup";
import { PopupContainer } from "../../Popup/PopupContainer";
import { TextField } from "../../TextField/TextField";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: 'flex',
    },
    field: {
        flex: '1 0 0',
        minWidth: 0,
    },
    listScroll: {
        flex: 1,
        overflowY: 'scroll',
    },
    list: {
        maxHeight: 300,
    },
    listItem: {
        justifyContent: 'center',
    },
    actions: {
        padding: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
    },
    actionButton: {
        padding: 0,
        margin: theme.spacing(0.5, 0),
        minWidth: 0,
        width: 64,
    },
}); }, { name: 'SnNumberPickerField' });
/**
 * 最小値以上最大値以下の正数列を返す関数
 * @param min 最小値
 * @param max 最大値
 * @returns 最小値から最大値まで1刻みの整数列の配列
 */
function range(min, max) {
    return __spreadArrays(Array(max - min + 1)).map(function (_, i) { return i + min; });
}
/**
 * 数値選択フィールド
 */
export var NumberPickerField = function (props) {
    var _a;
    var className = props.className, style = props.style, value = props.value, placeholder = props.placeholder, min = props.min, max = props.max, onChange = props.onChange, _b = props.clearable, clearable = _b === void 0 ? true : _b;
    // ポップアップ開閉
    var _c = useState(null), anchorRef = _c[0], setAnchorRef = _c[1];
    var _d = useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var handleOpen = useCallback(function () { return setIsOpen(true); }, []);
    var handleClose = useCallback(function () { return setIsOpen(false); }, []);
    // 選択肢
    var numbers = useMemo(function () {
        return range(min, max).map(function (i) { return ({
            id: "number-" + i,
            value: i,
            display: i.toString().padStart(2, '0'),
        }); });
    }, [min, max]);
    // コールバック
    var handleChange = useCallback(function (changedValue) { return function () {
        onChange === null || onChange === void 0 ? void 0 : onChange(changedValue);
        setIsOpen(false);
    }; }, [onChange]);
    var handleClear = useCallback(function () {
        onChange === null || onChange === void 0 ? void 0 : onChange(null);
        setIsOpen(false);
    }, [onChange]);
    var t = useTranslation().t;
    var classes = useStyles(props);
    return (React.createElement(PopupContainer, { className: classNames(classes.root, className), style: style },
        React.createElement("div", { className: classes.field, ref: setAnchorRef },
            React.createElement(TextField, { readonly: true, dense: true, placeholder: placeholder, value: (_a = value === null || value === void 0 ? void 0 : value.toString()) !== null && _a !== void 0 ? _a : '', onClick: handleOpen })),
        React.createElement(Popup, { open: isOpen, anchorEl: anchorRef, onClickAway: handleClose, portal: true, boundariesElement: "viewport" },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, className: classes.listScroll },
                    React.createElement(MenuList, { className: classes.list, onCancel: handleClose, onNext: handleClose }, numbers.map(function (numberItem) { return (React.createElement(MenuItem, { key: numberItem.id, className: classes.listItem, onClick: handleChange(numberItem.value), selected: value === numberItem.value }, numberItem.display)); })))),
            clearable && (React.createElement(React.Fragment, null,
                React.createElement(Divider, { thin: true }),
                React.createElement(Grid, { container: true, className: classes.actions, alignItems: "center", justify: "space-between" },
                    React.createElement(Button, { variant: "text", className: classes.actionButton, onClick: handleClear }, t('クリア')),
                    React.createElement(Button, { variant: "square", fill: true, className: classes.actionButton, onClick: handleClose }, t('OK'))))))));
};
